import { createReducer } from '@reduxjs/toolkit'

import { brandCampaignsTableColumnsConfig } from 'configuration/tables/campaignFactsTables'
import {
    CAMPAIGN_STATES,
    CAMPAIGN_NAME,
    CAMPAIGN_BUDGET,
    CAMPAIGN_TARGETING_TYPES,
    FACT_TYPES,
    LABELS,
    METRIC_FILTERS,
    DATES,
    AGGREGATION,
} from 'const/filters'
import { FILTER_SETTINGS, LOCAL_FILTERS } from 'const/reducerKeys'
import {
    ENABLED,
    CAMPAIGN_STATES as CAMPAIGN_STATES_OPTIONS,
} from 'const/resourceStates'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [LOCAL_FILTERS]: {
        [CAMPAIGN_NAME]: null,
        [FACT_TYPES]: [],
        [CAMPAIGN_BUDGET]: [],
        [CAMPAIGN_TARGETING_TYPES]: [],
        [LABELS]: [],
        [METRIC_FILTERS]: [],
        [CAMPAIGN_STATES]: [
            {
                value: ENABLED,
                label: CAMPAIGN_STATES_OPTIONS[ENABLED],
            },
        ],
    },
    [FILTER_SETTINGS]: {
        anchored: [],
        order: [
            DATES,
            AGGREGATION,
            CAMPAIGN_NAME,
            CAMPAIGN_STATES,
            CAMPAIGN_BUDGET,
            CAMPAIGN_TARGETING_TYPES,
            LABELS,
            METRIC_FILTERS,
        ],
        displayState: {},
        userAdded: [CAMPAIGN_STATES],
    },
    table: getDefaultTable(serializeColumns(brandCampaignsTableColumnsConfig)),
}

export default createReducer(initialState, () => {})
